<template>
  <div
    class="operation-report-show-footer-read w-full flex justify-center items-center"
  >
    <transaction-button
      v-for="transaction in executableWorkflowStatusTransactionsForDisplay"
      :key="transaction.id"
      :transaction="transaction"
      @click="() => onClickTransactionButton(transaction)"
      :disabled="transactionDisabled"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("operationReport");
import enterpriseWorkflowService from "@/services/enterprises/enterpriseWorkflowService";
import TransactionButton from "./TransactionButton";

import {
  notifyTransactionSuccess,
  notifyTransactionFailed,
  pushReportList,
} from "@/utils/operations";

import { ColorMixin } from "@/mixins";
const { AISEA_COLOR } = ColorMixin.data();

export default {
  name: "OperationReportShowFooterRead",
  components: { TransactionButton },

  computed: {
    ...mapGetters({
      executableWorkflowStatusTransactions:
        "executableWorkflowStatusTransactions",
      isRequiredFieldsFilled: "isRequiredFieldsFilled",
    }),
    executableWorkflowStatusTransactionsForDisplay() {
      return this.executableWorkflowStatusTransactions.map(transaction => {
        const color = this.transactionButtonColor(transaction);
        const type = this.buttonType(transaction);
        return {
          ...transaction,
          id: transaction.id,
          text: transaction.label,
          color,
          type,
          isProgress: enterpriseWorkflowService.isTransactionProgress(
            transaction
          ),
        };
      });
    },
    transactionDisabled() {
      // 未入力の必須項目があり、nullableCheckedも入っていない場合はトランザクション出来なくする
      return this.isRequiredFieldsFilled !== true;
    },
  },

  methods: {
    ...mapActions({
      transactionCurrentOperationReport: "transactionCurrentOperationReport",
    }),
    async onClickTransactionButton(transaction) {
      await this.tryTransactionOperationReport(transaction);
    },
    transactionButtonColor(transaction) {
      return enterpriseWorkflowService.isTransactionProgress(transaction)
        ? AISEA_COLOR.BLUE
        : AISEA_COLOR.DARK_GRAY;
    },
    buttonType(transaction) {
      return enterpriseWorkflowService.isTransactionProgress(transaction)
        ? "filled"
        : "border";
    },
    async tryTransactionOperationReport(
      { id: transactionId, label: transactionLabel } // transaction
    ) {
      try {
        this.$vs.loading({ color: AISEA_COLOR.BLUE });
        const result = await this.transactionCurrentOperationReport({
          transactionId,
        });
        if (!result.status) {
          throw new Error(result.message);
        }
        notifyTransactionSuccess(this, transactionLabel);
        pushReportList(this);
      } catch (e) {
        notifyTransactionFailed(this, transactionLabel);
      } finally {
        this.$nextTick(this.$vs.loading.close);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";
.operation-report-show-footer-read {
  column-gap: 25px;
}
</style>
